// extracted by mini-css-extract-plugin
export var addressFields = "_jy-0";
export var animationContainer = "_jy-1";
export var footer = "_jy-2";
export var lineItems = "_jy-3";
export var modalContent = "_jy-4";
export var orderName = "_jy-5";
export var strong = "_jy-6";
export var warning = "_jy-7";